module.exports = __webpack_public_path__ + "assets/NoImgMobileMenu-f85a09.svg";